import { API } from "aws-amplify";

import { initData } from "utils/utilAmplify";
import { generateErrorResponse } from "utils/helpers";

export const ChatsAPI = {
  get: async (path: string = "") => {
    try {
      return await API.get("UserChats", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  post: async (path: string = "", body: any) => {
    try {
      return await API.post("UserChats", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
};
